/**
 * Flagship builds — the homepage showcase of the three platforms we built
 * and run ourselves, replacing the old Work-in-Flight engagement cards
 * (July 2026 direction: showcase the transformations, not the tech).
 *
 * Cards are driven from the case-studies manifest by slug, so the homepage
 * and /case-studies can never drift apart: edit the study, both update.
 */
export const flagshipBuilds = {
  eyebrow: 'Flagship builds',
  heading: 'The platforms we built and run ourselves.',
  description:
    'Merlin answers our own front door. Narawe reads a firm\'s entire paper history. Otsukare runs a marketplace in two languages at once. We publish how each one is built, because the same discipline goes into every client system.',
  slugs: [
    'merlin-voice-agent',
    'document-intelligence-platform',
    'bilingual-marketplace-prototype',
  ],
  linkLabel: 'Read the case studies',
};
